import { FormBase } from 'core/components';

export default class ReportForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.state.options.set({
			validateOnChange: false,
			validateOnChangeAfterSubmit: true,
		});
	}

	setup() {
		return {
			fields: [
				{
					name: 'organizationId',
					label: 'REPORTS.ORGANIZATION',
				},
				{
					name: 'name',
					label: 'REPORTS.NAME',
					rules: 'required',
				},
				{
					name: 'reportCategoryId',
					label: 'REPORTS.CATEGORY',
					rules: 'required',
				},
				{
					name: 'templateId',
					label: 'REPORTS.TEMPLATE',
				},
				{
					name: 'reportUserIds',
					label: 'REPORTS.RECIPIENTS',
					rules: 'required',
				},
				{
					name: 'frequencyId',
					label: 'REPORTS.FREQUENCY',
					rules: 'required',
				},
				{
					name: 'scheduledDate',
					label: 'REPORTS.SCHEDULEDATE',
					rules: 'required',
				},
				{
					name: 'sendAt',
					label: 'REPORTS.SENDAT',
					rules: 'required',
				},
				{
					name: 'isActive',
					label: 'REPORTS.ISACTIVE',
					type: 'checkbox',
					value: true,
				},
				{
					name: 'useSpecificDate',
					label: 'REPORTS.USESPECIFICDATE',
					value: false,
				},
				{
					name: 'specificDate',
					label: 'REPORTS.FILTERDATE',
				},
				{
					name: 'reportTypeId',
					label: '',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/report/forms/ReportForm.js